import { TriagemData } from "../interfaces/triagem.interface";

export type TriagemFormData = TriagemData;

export const getInitialData = (initialData?: Partial<TriagemData>): TriagemFormData => {
  return {
    id_empresa: initialData?.id_empresa ?? "",
    id: initialData?.id ?? "",
    motivoConsulta: initialData?.motivoConsulta ?? "",
    historicoMedico: initialData?.historicoMedico ?? "",
    medicamentos: initialData?.medicamentos ?? "",
    alergias: initialData?.alergias ?? "",
    cirurgiasAnteriores: initialData?.cirurgiasAnteriores ?? "",
    pressaoArterial: initialData?.pressaoArterial ?? "",
    frequenciaCardiaca: initialData?.frequenciaCardiaca ?? "",
    temperatura: initialData?.temperatura ?? "",
    peso: initialData?.peso ?? "",
    altura: initialData?.altura ?? "",
    imc: initialData?.imc ?? "",
    estadoGeral: initialData?.estadoGeral ?? "",
    observacoes: initialData?.observacoes ?? "",
    fumaCigarros: initialData?.fumaCigarros ?? "",
    usaAlcool: initialData?.usaAlcool ?? "",
    praticaExercicios: initialData?.praticaExercicios ?? "",
    status_atendimento: initialData?.status_atendimento ?? "",
  };
};
